import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Waves, Wifi, Sun, Flame, BedDouble, ChefHat, Wind, Ban } from "lucide-react";

const ICONS = [Waves, Wifi, Sun, Flame, BedDouble, ChefHat, Wind, Ban];

export default function Amenities() {
  const { t } = useLang();

  return (
    <section id="amenities" data-testid="amenities-section" className="py-24 md:py-32 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 md:mb-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-8">
            <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#C48E66] mb-6" data-testid="amenities-eyebrow">{t.amenities.eyebrow}</p>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#112A46] leading-[1.02] tracking-tight font-light" data-testid="amenities-title">
              {t.amenities.title_1}<span className="italic">{t.amenities.title_italic}</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E2DFD2]" data-testid="amenities-grid">
          {t.amenities.items.map((item, i) => {
            const Icon = ICONS[i] || Waves;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="bg-[#FAFAF7] p-8 md:p-10 flex flex-col gap-5 min-h-[180px] hover:bg-[#F0EBE1] transition-colors duration-500"
                data-testid={`amenity-${i}`}
              >
                <Icon size={28} strokeWidth={1} className="text-[#112A46]" />
                <span className="font-serif text-xl md:text-2xl text-[#1C2321] leading-tight">{item.t}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
